// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  height: 400px;
}

.sidebar {
  background-color: rgba(35, 55, 75, 0.9);
  color: #ffffff;
  padding: 6px 12px;
  font-family: monospace;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  margin: 12px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/Custom/index.css"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEI;EACA,uCAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;AACJ","sourcesContent":[".map-container {\n    height: 400px;\n    }\n     \n    .sidebar {\n    background-color: rgba(35, 55, 75, 0.9);\n    color: #ffffff;\n    padding: 6px 12px;\n    font-family: monospace;\n    z-index: 1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: 12px;\n    border-radius: 4px;\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
